"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNumber = void 0;
var accounting_js_1 = require("accounting-js");
/**
 * Converts a formatted number or currency `String` to its equivalent `Number` value.
 * Wrapper for accounting-js `parse` (http://openexchangerates.github.io/accounting.js/#methods).
 *
 * @hidden
 * @param value The formatted string to be parsed.
 * @param decimalSeparator The decimal separator symbol used in the formatted string.
 * @returns The parsed `Number` value.
 */
var parseNumber = function (value, decimalSeparator) {
    return accounting_js_1.parse(value, decimalSeparator);
};
exports.parseNumber = parseNumber;
//# sourceMappingURL=parse-number.js.map